import React from 'react';
import { FormProvider } from 'react-hook-form';
import { Form, Row, Col } from 'reactstrap';
import SectionProgress from './parts/SectionProgress';
import QuestionProgress from './parts/QuestionProgress';
import Section from './parts/Section';
import Question from './parts/Question';
import Submit from './parts/Submit';
import { useSurvey } from './hooks/useSurvey';
import { Survey as SurveyModel } from './types';
import { useMobile } from '@octano/global-ui';
import SectionProgressMobile from './parts/SectionProgressMobile';

export type SurveyProps = {
  survey: SurveyModel;
  onSubmit: (data: Record<string, any>) => void;
};

const Survey: React.FC<SurveyProps> = ({ survey, onSubmit }) => {
  const isMobile = useMobile();
  const formClass = isMobile
    ? 'd-flex flex-column px-4 pb-2'
    : 'd-flex flex-column px-5 pb-5';
  const titleClass = isMobile
    ? 'h4 text-primary'
    : 'h3 text-primary text-center pt-3';

  const {
    methods,
    handleSubmit,

    totalSteps,
    totalSections,

    currentSection,
    currentIdx,
    currentQuestion,
    currentSectionIndex,
    currentQuestionIndex,

    goPrev,
    goNext,

    isSubmitStep,
  } = useSurvey(survey);

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)} className={formClass}>
        {/* Progreso de secciones mobile*/}
        {isMobile && (
          <Row className="pb-4">
            <Col xs={12} md={10} style={{ margin: '0 auto' }}>
              <SectionProgressMobile
                total={totalSections}
                currentIndex={currentSectionIndex}
              />
            </Col>
          </Row>
        )}

        {/* Título */}
        <Row className="pt-3 justify-content-center">
          <Col xs={12} md={10} style={{ margin: '0 auto' }}>
            <div className={titleClass} style={{ fontWeight: 600 }}>
              {survey.title.toUpperCase()}
            </div>
          </Col>
        </Row>

        {/* Progreso de secciones */}
        {!isMobile && (
          <Row className="pt-3 justify-content-center">
            <Col xs="auto">
              <SectionProgress
                total={totalSections}
                currentIndex={currentSectionIndex}
              />
            </Col>
          </Row>
        )}

        <Row className={!isMobile ? 'pt-3' : undefined}>
          <Col xs={12} md={10} style={{ margin: '0 auto' }}>
            {!isSubmitStep && <Section section={currentSection} />}
          </Col>
        </Row>

        {/* Preguntas */}
        <Row className="pt-3">
          <Col xs={12} md={10} style={{ margin: '0 auto' }}>
            {/* La key fuerza el remount por paso: sin ella el textarea de una
                pregunta abierta se reutiliza en el paso siguiente (otra abierta
                o la observación general) y arrastra el texto anterior. */}
            {!isSubmitStep && currentQuestion ? (
              <Question
                key={currentQuestion.id}
                question={currentQuestion}
                index={currentQuestionIndex!}
              />
            ) : (
              <Submit key="submit" />
            )}
          </Col>
        </Row>

        <Row className="pt-3 justify-content-center">
          <QuestionProgress
            current={currentIdx + 1}
            total={totalSteps}
            onPrev={goPrev}
            onNext={goNext}
            disabledNext={isSubmitStep}
          />
        </Row>
      </Form>
    </FormProvider>
  );
};

export default Survey;
